module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"quotation":"Quotation","in-progress":"In progress","waiting-quotation":"Waiting","sent-quotation":"Sent request","sent-request":"Sent request","search":"Search","items":""},"ja":{"quotation":"受信トレイ","in-progress":"作成","waiting-quotation":"認証完了","sent-quotation":"提出済み","sent-request":"提出済み","search":"検索","items":"件"}}')
  delete Component.options._Ctor
}
